export default __webpack_public_path__ + "static/media/Fresh-Air.bf1c9f95.png";